import { DatePicker, Select } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link, useSearchParams } from "react-router-dom";
import { get_states_auditory } from "../../../../api/endpoints/auditory";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import Main from "../../../layout/main/Main";
import { Typo } from "../../../layout/theme";
import {
	AntdButton,
	SelectorContainer,
	FilterContainer,
	ImageSection,
	InnerBody,
	PageWrapper,
	ContentCard,
	PageTitle,
	Inner,
	AuditCard,
	SectionTitle,
	FilterGrid,
	FieldGroup,
	FieldLabel,
} from "./styles";
import { useEffect } from "react";
import { get_distributors_name_list_with_orders_CT } from "../../../../api/endpoints/distributors";
import AntdSelect from "../../../common/antd-select/AntdSelect";

export default function LaboratoryStatesAuditory({ clientId, userId }) {
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [selectedDistributor, setSelectedDistributor] = useState(null);
	const [distributors, setDistributors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedQuarter, setSelectedQuarter] = useState(null);

	const fetch_distributors = async () => {
		const month = selectedMonth ? moment(selectedMonth).month() + 1 : 0;
		const year = selectedMonth
			? moment(selectedMonth).year()
			: selectedQuarter
				? moment(selectedQuarter).year()
				: 0;
		const res = await get_distributors_name_list_with_orders_CT(
			"",
			clientId,
			month,
			year,
		);
		setDistributors(
			res?.distributors.map((r) => ({
				value: r.id,
				label: r.name,
			})) || [],
		);
	};

	useEffect(() => {
		if (selectedMonth || selectedQuarter) fetch_distributors();
	}, [selectedMonth, selectedQuarter]);

	const handleSubmit = async () => {
		if (!selectedMonth) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un mes",
				"Elija un mes para poder descargar la auditoría mensual.",
			);
			return;
		}

		// if (!selectedDistributor) {
		// 	openNotificationWithIcon(
		// 		TYPE.ERROR,
		// 		"Falta elegir una droguería",
		// 		"Elija una droguería para poder descargar la auditoría mensual."
		// 	);
		// 	return;
		// }

		setIsLoading(true);
		try {
			const data = {
				month: moment(selectedMonth).month() + 1,
				year: moment(selectedMonth).year(),
				quarter: 0,
				client: clientId,
				distributorId: selectedDistributor,
			};
			const res = await get_states_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
				data.distributorId,
			);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_States_" +
				"Month_" +
				data.month +
				"_Year_" +
				data.year +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	const handleSubmitYear = async () => {
		if (!selectedQuarter) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un año",
				"Elija un año para poder descargar la auditoría anual.",
			);
			return;
		}

		// if (!selectedDistributor) {
		// 	openNotificationWithIcon(
		// 		TYPE.ERROR,
		// 		"Falta elegir una droguería",
		// 		"Elija una droguería para poder descargar la auditoría mensual."
		// 	);
		// 	return;
		// }

		setIsLoading(true);
		try {
			const data = {
				month: 0,
				year: moment(selectedQuarter).year(),
				quarter: moment(selectedQuarter).quarter(),
				client: clientId,
				distributorId: selectedDistributor,
			};
			const res = await get_states_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
				data.distributorId,
			);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_States_" +
				"Year_" +
				data.year +
				"_Quarter_" +
				data.quarter +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Auditoria estados
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<PageWrapper>
					<ContentCard>
						<PageTitle>Gestión de Auditorías de estados</PageTitle>
						<Inner>
							<AuditCard>
								<SectionTitle>Auditoría Mensual</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Seleccionar Mes</FieldLabel>
										<FilterContainer>
											<DatePicker.MonthPicker
												value={selectedMonth}
												onChange={(e) => setSelectedMonth(e)}
												placeholder="Seleccionar mes"
												format="MMMM YYYY"
												style={{ width: 220 }}
											/>
											<AntdSelect
												showSearch
												allowClear
												placeholder="Droguería"
												optionFilterProp="children"
												value={selectedDistributor}
												onChange={(e) => setSelectedDistributor(e)}
												filterOption={(input, option) =>
													(option?.label ?? "")
														.toLowerCase()
														.includes(input.toLowerCase())
												}
												options={distributors}
												style={{ width: 220, marginLeft: 20 }}
											/>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<AntdButton
											onClick={handleSubmit}
											loading={isLoading}
											style={{ width: 320 }}
										>
											<BsDownload />
											Descargar Auditoría Mensual
										</AntdButton>
									</FieldGroup>
								</FilterGrid>
							</AuditCard>

							<AuditCard>
								<SectionTitle>Auditoría Trimestral</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Seleccionar Trimestre</FieldLabel>
										<FilterContainer>
											<DatePicker.QuarterPicker
												value={selectedQuarter}
												onChange={(e) => setSelectedQuarter(e)}
												placeholder="Seleccionar trimestre"
												picker="quarter"
												format="[Q]Q YYYY"
												style={{ width: 220 }}
											/>
											<AntdSelect
												showSearch
												allowClear
												placeholder="Droguería"
												optionFilterProp="children"
												value={selectedDistributor}
												onChange={(e) => setSelectedDistributor(e)}
												filterOption={(input, option) =>
													(option?.label ?? "")
														.toLowerCase()
														.includes(input.toLowerCase())
												}
												options={distributors}
												style={{ width: 220, marginLeft: 20 }}
											/>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<AntdButton
											onClick={(e) => handleSubmitYear(e)}
											loading={isLoading}
											style={{ width: 320 }}
										>
											<BsDownload />
											Descargar Auditoría Trimestral
										</AntdButton>
									</FieldGroup>
								</FilterGrid>
							</AuditCard>
						</Inner>
					</ContentCard>
				</PageWrapper>
			</Main.Body>
		</Main>
	);
}
